import React from 'react';
import ReactDOM from 'react-dom/client';

import './global-styles.css';
import { readUrlState, MODES } from './urlParams';
import App from './components/App';
import LabelApp from './components/LabelApp';

const root = ReactDOM.createRoot(document.getElementById('root'));
const urlState = readUrlState();
// LabelApp is a fully separate app shell (different providers, no drawing
// canvas), so it dispatches at the root rather than living as a mode inside
// <App />.
root.render(
  urlState.mode === MODES.LABEL ? <LabelApp marcId={urlState.marcId} /> : <App />,
);
